module.exports = __webpack_public_path__ + "img/user_elin.e0bb7625.png";